const state = {
  currentTopicReplies: [],
  replieForm: {
    content: '',
  },
};

export default state;
